<styles-smart-table
  #smartTable
  [datasource]="content.items"
  [expandable]="expandable"
  [mainColumns]="columnBuilder.getAllColumnNames()"
  [expandedColumns]="['details']"
  [showColumnHeaders]="showColumnHeaders"
>
  <ng-container matColumnDef="type">
    <td mat-cell *matCellDef="let element" [attr.colspan]="columnBuilder.getAllColumnNames().length || 0">
      <div style="position: relative; top: 5px">{{$any(element)?.type }}</div>
    </td>
  </ng-container>

  <ng-container matColumnDef="image">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="image"></th>
    <td
      mat-cell
      *matCellDef="let element"
      [attr.rowspan]="smartTable.getImageRows(element)"
      [sharedListingColumnWidth]="columnBuilder"
      columnName="image"
    >
      <framework-assets-image
        image
        [assetSet]="$safeNavigationMigration($any(element)?.defaultAsset)"
        [size]="130"
        [style.height.px]="smartTable.isExpanded(element) ? 124 : 44"
      >
      </framework-assets-image>
    </td>
  </ng-container>

  <ng-container matColumnDef="date">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="date">Date</th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="date">
      @if (element.contentStatus.id !== 'Completed') {
      <styles-icon-value-caption caption="Publish date" icon="date_range">
        {{ $any(element)?.publishDate | date : 'mediumDate' }}
      </styles-icon-value-caption>
      } @else {
      <styles-icon-value-caption caption="Published date" icon="date_range">
        {{ $any(element)?.publishDate | date : 'mediumDate' }}
      </styles-icon-value-caption>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="organization">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="organization">
      Organization
    </th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="organization">
      @if (element.feedDetails) {
      <styles-icon-value-caption caption="Organization" icon="corporate_fare">
        {{ $any(element)?.feedDetails.organizationName || $any(element)?.feedDetails.feedName}}
      </styles-icon-value-caption>
      }
    </td>
  </ng-container>

  <ng-container matColumnDef="details">
    <td mat-cell *matCellDef="let element" [attr.colspan]="5">
      <div class="details-flex-wrapper">
        <framework-clusted-profile-images
          [userList]="$safeNavigationMigration($any(element)?.members)"
          [numberToShow]="10"
        >
        </framework-clusted-profile-images>

        @if ($any(element).tags) {
        <styles-icon-value-caption caption="Tags">
          @for (tag of $any(element).tags; track tag) {
          <framework-tag-chip [tag]="tag"> </framework-tag-chip>
          }
        </styles-icon-value-caption>
        } @if ($any(element)?.feedDetails?.feedName) {
        <styles-icon-value-caption caption="Organization" icon="corporate_fare">
          {{ $any(element).feedDetails?.feedName }}
        </styles-icon-value-caption>
        } @if ($any(element)?.campaign) {
        <styles-icon-value-caption caption=" Campaign" icon="star">
          {{ $any(element).campaign.name }}
        </styles-icon-value-caption>
        } @if ($any(element)?.productType) {
        <styles-icon-value-caption caption="Product Type" icon="campaign">
          {{ $any(element).productType.name }}
        </styles-icon-value-caption>
        }
      </div>
    </td>
  </ng-container>

  <ng-container matColumnDef="default">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="default">Name</th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="default">
      <a [routerLink]="element | findRoute">
        <div class="title ellipsis-text">{{$any(element)?.name }}</div>

        @if ((element | workInType : 'MasterProject') && (element | masterSpaceTaskCount)) {
        <framework-master-project-progress-line [masterProject]="element" [rounding]="true" [stroke]="6" [gap]="3">
        </framework-master-project-progress-line>
        } @else {
        <framework-space-progress-line [space]="element" [rounding]="true" [stroke]="6">
        </framework-space-progress-line>
        }
      </a>
    </td>
  </ng-container>

  <ng-container matColumnDef="status">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="status">Status</th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="status">
      <framework-work-status-chip
        [workStatus]="$safeNavigationMigration($any(element)?.status)"
      ></framework-work-status-chip>
    </td>
  </ng-container>

  <ng-container matColumnDef="owner">
    <th mat-header-cell *matHeaderCellDef [sharedListingColumnWidth]="columnBuilder" columnName="owner">Owner</th>
    <td mat-cell *matCellDef="let element" [sharedListingColumnWidth]="columnBuilder" columnName="owner">
      <span class="owner-wrapper">
        <framework-person-image [person]="element.owner" size="33px"></framework-person-image>
        <span class="name">{{ element.owner.name }}</span>
      </span>
    </td>
  </ng-container>
</styles-smart-table>
